import { schema } from "normalizr";

export const course = new schema.Entity("courses");
